
    window.EXCALIDRAW_ASSET_PATH = "/";
  